<template>
  <div>
    <v-list two-line>
      <v-subheader>Configurações</v-subheader>
      <v-list-tile @click="openProductsDialog">
        <v-list-tile-avatar>
          <v-icon>event</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>Produtos e Setores</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider></v-divider>
    </v-list>
    <products-config />
  </div>
</template>

<script>
import ProductsConfig from './ProductsConfig'
export default {
  components: { ProductsConfig },
  created() {
    this.$store.dispatch('setCurrentPage', 'Configurações')
  },
  methods: {
    openProductsDialog() {
      this.$store.dispatch('openProductsConfigDialog')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/configs/Configs.vue